"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedLengthArray = void 0;
// external
const t = __importStar(require("io-ts"));
/**
 * The refinement for encoding/decoding strings of fixed length
 *
 * @param min - The array min length
 * @param max - The array max length
 * @param a - The array type
 * @returns The fixed length array codec
 */
const FixedLengthArray = (min, max, a) => t.brand(t.array(a), (n) => min <= n.length && n.length <= max, 'fixedLengthArray');
exports.FixedLengthArray = FixedLengthArray;
//# sourceMappingURL=FixedLengthArray.js.map